/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { EventItemList } from '../../models/event-item-list';

export interface EventControllerGetAll$Params {
  monitoringId: number;
  subject?: string;
  statusId?: number;
  query?: string;
  fromDateEvent?: string;
  toDateEvent?: string;
  field?: 'id' | 'subject' | 'eventDate';
  direction?: 'asc' | 'desc';
  limit?: number;
  skip?: number;
}

export function eventControllerGetAll(http: HttpClient, rootUrl: string, params: EventControllerGetAll$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: EventItemList;
}>> {
  const rb = new RequestBuilder(rootUrl, eventControllerGetAll.PATH, 'get');
  if (params) {
    rb.path('monitoringId', params.monitoringId, {});
    rb.query('subject', params.subject, {});
    rb.query('statusId', params.statusId, {});
    rb.query('query', params.query, {});
    rb.query('fromDateEvent', params.fromDateEvent, {});
    rb.query('toDateEvent', params.toDateEvent, {});
    rb.query('field', params.field, {});
    rb.query('direction', params.direction, {});
    rb.query('limit', params.limit, {});
    rb.query('skip', params.skip, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: EventItemList;
      }>;
    })
  );
}

eventControllerGetAll.PATH = '/monitoring/{monitoringId}/events';
